import { PropsWithChildren } from 'react';
import { ButtonProps } from '../02-atoms/Button';
import { ButtonGroup } from './ButtonGroup';
import { sanitizeLinksOnly } from '../../utils/sanitize';

export interface MessageProps extends PropsWithChildren {
  /** Type */
  type: 'info' | 'warning' | 'error' | 'success';
  /** Title */
  title?: string;
  /** Description */
  description?: string;
  /** Actions */
  actions?: ButtonProps[];
  /** Additional class */
  className?: string;
  /** onClick handler */
  onClick?: () => void;
}

/** A message */
export const Message = ({
  type = 'info',
  title,
  description,
  actions,
  className,
  children,
  ...props
}: MessageProps) => {
  return (
    <div
      className={['message', `message--${type}`, className].join(' ')}
      role="alert"
      {...props}
    >
      <p className="message__content">
        {title && (
          <strong
            dangerouslySetInnerHTML={{ __html: sanitizeLinksOnly(title) }}
          ></strong>
        )}
        {description && <span>{description}</span>}
        {children}
      </p>
      {actions && (
        <ButtonGroup
          className="message__actions"
          size="small"
          items={actions}
        />
      )}
    </div>
  );
};
